import { Empty, message, Modal, Progress, Upload } from 'antd';
import { EmptyIcon } from 'assets/icon/bigicon';
import { ForwardIcon, LayerIcon, SortIcon } from 'assets/icon';
import { ExportIcon, ImportIcon } from 'assets/icon/dynamic';
import axios from 'axios';
import ModalCategoryForm from 'components/ModalCategoryForm';
import ModalDelete from 'components/ModalDelete';
import ModalFloorForm from 'components/ModalFloorForm';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import {
  createCategory,
  deleteCategory,
  fetchCategories,
  modifyCategory,
  setCategory,
} from 'state/actions/categories';
import {
  createFloor,
  deleteFloor,
  fetchFloor,
  modifyFloor,
  setFloor,
} from 'state/actions/floor';
import {
  deletePoi,
  downloadPois,
  fetchPois,
  removePoi,
} from 'state/actions/pois';
import _ from 'underscore';
import { getAccess, log, refreshToken } from 'utils';
import { url } from 'utils/url';
import Cards from 'design-components/Cards';
import CategoryDropdown from 'components/CategoryDropdown';
import { setTabTenant } from 'state/actions/breadcrumb';
import { getRole } from 'utils/secrets';
import { fetchEditorData } from 'state/actions/editors';
import './Pois.css';


function Pois({ history }) {
  const [search, setSearch] = useState();
  // const [floor, setFloor] = useState();
  const [modalUpload, setModalUpload] = useState(false);
  const [isDragged, setIsDragged] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [progress, setProgress] = useState(0);

  const [selectedCategory, setSelectedCategory] = useState('all');
  const [tempSelectedCategory, setTempSelectedCategory] =
    useState(selectedCategory);
  const [playlistOpen, setPlaylistOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);

  const [selectedFloor, setSelectedFloor] = useState('all');
  const [tempSelectedFloor, setTempSelectedFloor] = useState(selectedFloor);
  const [floorOpen, setFloorOpen] = useState(false);
  const [selectedLinkFilter, setSelectedLinkFilter] = useState('all');
  const [tempSelectedLinkFilter, setTempSelectedLinkFilter] =
    useState(selectedLinkFilter);
  const [linkOpen, setLinkOpen] = useState(false);
  const linkFilters = [
    { _id: 'full', name: 'Linked to Shape' },
    { _id: 'partial', name: 'Partial Linked to Shape' },
    { _id: 'none', name: 'Unlinked to Shape' },
  ];
  const [sortBy, setSortBy] = useState({
    sort: 'name',
    direction: 'asc',
  });
  const [sortByTemp, setSortByTemp] = useState(sortBy);
  const [modalCategory, setModalCategory] = useState(false);
  // const [isEditing, setIsEditing] = useState(false);
  const [modalDeleteCategory, setModalDeleteCategory] = useState({
    show: false,
    category: null,
  });

  // const [isEditingFloor, setIsEditingFloor] = useState(false);
  const [modalFloor, setModalFloor] = useState(false);
  const [access, setAccess] = useState(null);
  const [modalDeleteFloor, setModalDeleteFloor] = useState({
    show: false,
    floor: null,
  });

  const { siteId, siteName } = useParams();

  const {
    poisList,
    loading,
    categoriesList,
    // downloading,
    floorList,
    siteList,
    category,
    userData,
    categoryLoading,
    floor,
    floorLoading,
    selectedTab,
    shapesSize,
  } = useSelector(
    (state) => ({
      poisList: state.pois.list,
      loading: state.pois.loading,
      // downloading: state.pois.downloading,
      deleted: state.pois.deleted,
      categoriesList: state.categories.list,
      floorList: state.floor.list,
      siteList: state.sites.list,
      category: state.categories.category,
      userData: state.auth.userData,
      categoryLoading: state.categories.loading,
      floor: state.floor.floor,
      floorLoading: state.floor.loading,
      selectedTab: state.breadcrumb.tenant,
      shapesSize:
        state.editors.shapes instanceof Map ? state.editors.shapes.size : 0,
    }),
    shallowEqual
  );

  const site = siteList.find((s) => s._id === siteId);

  const [deleteModal, setDeleteModal] = useState({
    poisListSorted: null,
    isOpen: false,
  });
  const [role, setRole] = useState(null);

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const fetchData = async () => {
    try {
      const roleData = await getRole();
      setRole(roleData);
    } catch (error) {
      log('Error retrieving role:', error);
    }
  };

  const dispatch = useDispatch();
  const uid = userData.id;

  useEffect(() => {
    dispatch(fetchCategories({ siteId }));
    dispatch(fetchFloor({ siteId }));
    setSelectedCategory('all');
    setSelectedFloor('all');
    if (site && (site.isUsingAdsignEditor || site.editorSiteId)) {
      dispatch(fetchEditorData({ siteId: site.editorSiteId }));
    }
    // dispatch(fetchMaps({ siteId: siteId }));
  }, [siteId, site?.editorSiteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (userData && userData.roleAccess) {
      setAccess(getAccess(userData, 'tenant', siteId));
    }
  }, [userData, siteId]);

  useEffect(() => {
    dispatch(
      fetchPois({ siteId, categoryId: selectedCategory, type: selectedTab })
    );
  }, [siteId, selectedCategory, selectedTab, shapesSize]); // eslint-disable-line react-hooks/exhaustive-deps

  if (poisList) {
    log(poisList, '<<<< pois list');
  }


  const onRemoveButtonClickHandler = (poi) => {
    setDeleteModal((prevState) => ({
      poi,
      isOpen: !prevState.isOpen,
    }));
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ poi: null, isOpen: false });
  };

  const onDeletePoiHandler = () => {
    log('delete poi clicked', deleteModal);
    if (selectedTab === 'archived') {
      dispatch(
        deletePoi({ id: deleteModal.poi, siteId }, () => {
          onCloseModalHandler();
        })
      );
    } else {
      dispatch(
        removePoi({ id: deleteModal.poi, siteId }, () => {
          onCloseModalHandler();
        })
      );
    }
  };



  const onFileChangedHandler = async (file) => {
    setIsDragged(false);
    if (file.type !== 'text/csv') {
      message.error('File format must be csv!');
    } else {
      log(file);
      setIsUploaded(true);

      const token = await refreshToken();

      const config = {
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      let data = new FormData();
      data.append('file', file);
      data.set('siteId', siteId);

      axios
        .post(`${url}/poi/import`, data, config)
        .then((res) => {
          message.success(res.data.message);
          setModalUpload(false);
          dispatch(
            fetchPois({
              siteId,
              categoryId: selectedCategory,
              type: selectedTab,
            })
          );
        })
        .catch((err) => {
          if (err.response) {
            message.error(err.response.data.message);
          } else {
            message.error('Server is stopped');
          }
        })
        .finally(() => {
          setIsUploaded(false);
        });
    }
  };

  const handleSearch = (e) => {

    setSearch(e.target.value);
  };

  const poisListSorted =
    sortBy.direction === 'desc'
      ? _.sortBy(poisList, sortBy.sort).reverse()
      : _.sortBy(poisList, sortBy.sort);

  const dataByFloor = poisListSorted.filter((poi) => {
    return selectedFloor !== 'all' ? poi.floorId === selectedFloor : true;
  });

  const dataByLinkFilter = dataByFloor.filter((poi) => {
    return selectedLinkFilter !== 'all'
      ? poi.hasShape?.toString() === selectedLinkFilter
      : true;
  });

  const filteredData = search
    ? dataByLinkFilter.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name.toLowerCase().includes(search.toLowerCase());
      })
    : dataByLinkFilter;

  const getShapeTagProps = (poi) => {
    if (role === 'superadmin') {
      if (poi.hasShape === 'full') {
        return { tagged: 'Linked to Shape', taggedColor: 'green' };
      }
      if (poi.hasShape === 'partial') {
        return { tagged: 'Partially linked to shape', taggedColor: 'yellow' };
      }
    }
    return {};
  };

  const handleSetLinkFilter = () => {
    setSelectedLinkFilter(tempSelectedLinkFilter);
    setLinkOpen(false);
  };

  const getCategory = (categoryId) => {
    const findCategory = categoriesList.find((cat) => cat._id === categoryId);
    return findCategory?.name;
  };

  const handleSetPlaylist = () => {
    setSelectedCategory(tempSelectedCategory);
    setPlaylistOpen(false);
  };

  const handleEdit = (id) => {
    history.push(`/${siteId}/information/${siteName}/pois/${id}`);
  };

  const getFloor = () => {
    const findFloor = floorList.find((floor) => floor._id === selectedFloor);
    return findFloor?.name;
  };

  const handleSortTemp = (type, value) => {
    setSortByTemp({
      ...sortByTemp,
      [type]: value,
    });
  };

  const handleSort = () => {
    setSortBy(sortByTemp);
    setSortOpen(false);
  };

  const handleSetCategory = (data) => {
    dispatch(setCategory(data));
  };

  const onSubmitCategory = () => {
    const action = category._id ? modifyCategory : createCategory;

    dispatch(
      action({ ...category, siteId, id: category._id, uid }, () =>
        setModalCategory(false)
      )
    );
  };

  const handleEditCategory = (category) => {
    // setIsEditing(true);
    dispatch(setCategory(category, () => setModalCategory(true)));
  };

  const handleDeleteCategory = (category) => {
    setModalDeleteCategory({
      show: true,
      category,
    });
  };

  const onDeleteCategory = () => {
    dispatch(
      deleteCategory(modalDeleteCategory.category._id, () =>
        onCloseModalCategoryHandler()
      )
    );
  };

  const onCloseModalCategoryHandler = () => {
    setModalDeleteCategory({
      show: false,
      category: null,
    });
  };

  const onSubmitFloor = () => {
    const action = floor._id ? modifyFloor : createFloor;

    dispatch(
      action({ uid, ...floor, siteId, id: floor._id }, () =>
        setModalFloor(false)
      )
    );
  };

  const handleSetFloor = (data) => {
    dispatch(setFloor(data));
  };

  const handleSetFloorCategory = () => {
    setSelectedFloor(tempSelectedFloor);
    setFloorOpen(false);
  };

  const handleEditFloor = (floor) => {
    // setIsEditingFloor(true);
    dispatch(setFloor(floor));
    setModalFloor(true);
  };

  const handleDeleteFloor = (floor) => {
    setModalDeleteFloor({
      show: true,
      floor,
    });
  };

  const onDeleteFloor = () => {
    dispatch(
      deleteFloor(modalDeleteFloor.floor._id, () => onCloseModalFloorHandler())
    );
  };

  const onCloseModalFloorHandler = () => {
    setModalDeleteFloor({
      show: false,
      floor: null,
    });
  };

  const handleCancel = () => {
    console.log('cancelled');
    dispatch(
      setCategory(
        {
          _id: '',
          name: '',
          description: '',
          siteId: '',
          modifiedAt: new Date().toDateString(),
          modifiedBy: '',
        },
        () => setModalCategory(false)
      )
    );
  };

  const handleNew = () => {
    dispatch(
      setCategory(
        {
          _id: '',
          name: '',
          description: '',
          siteId: '',
          modifiedAt: new Date().toDateString(),
          modifiedBy: '',
        },
        () => setModalCategory(true)
      )
    );
  };

  const handleNewFloor = () => {
    dispatch(
      setFloor(
        {
          _id: '',
          name: '',
          description: '',
        },
        () => setModalFloor(true)
      )
    );
  };

  return (
    <div className="media-library">
      <ModalCategoryForm
        visible={modalCategory}
        onCancel={handleCancel}
        onCreate={onSubmitCategory}
        category={category}
        setCategory={handleSetCategory}
        isEditing={category._id ? true : false}
      />

      <ModalFloorForm
        visible={modalFloor}
        onCancel={() => {
          setModalFloor(false);
        }}
        onCreate={onSubmitFloor}
        floor={floor}
        setFloor={handleSetFloor}
        isEditing={floor._id ? true : false}
      />

      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={onDeletePoiHandler}
        onCancel={onCloseModalHandler}
        title="Delete Tenant"
        subtitle={deleteModal.poi ? deleteModal.poi.name : ''}
        loading={loading}
      />

      <ModalDelete
        isVisible={modalDeleteCategory.show}
        onOk={onDeleteCategory}
        onCancel={onCloseModalCategoryHandler}
        title="Delete Category"
        subtitle={
          modalDeleteCategory.category ? modalDeleteCategory.category.name : ''
        }
        loading={categoryLoading}
      />

      <ModalDelete
        isVisible={modalDeleteFloor.show}
        onOk={onDeleteFloor}
        onCancel={onCloseModalFloorHandler}
        title="Delete Floor"
        subtitle={modalDeleteFloor.floor ? modalDeleteFloor.floor.name : ''}
        loading={floorLoading}
      />

      <Modal
        footer={false}
        onCancel={() => {
          setModalUpload(false);
          setIsUploaded(false);
        }}
        visible={modalUpload}
        title="Import Tenant"
        className="modal-poi-upload adsign-modal"
        closeIcon={<i className="feather-x" />}
      >
        {isUploaded ? (
          <div className="upload-loading">
            <p>
              <i className="mdi mdi-loading mdi-spin" />
              Uploading...
            </p>
            <Progress percent={progress} />
          </div>
        ) : (
          <div className="upload-wrapper">
            <p>Upload</p>
            <Upload
              showUploadList={false}
              beforeUpload={onFileChangedHandler}
              style={{ width: '100%' }}
            >
              <div
                onDragLeave={() => setIsDragged(false)}
                onDragOver={() => setIsDragged(true)}
                className={`modal-drop upload-drag-and-drop  ${
                  isDragged ? 'active' : ''
                }`}
              >
                <ExportIcon size={22} color="#C2C2C2" />
                <p className="upload-title">
                  Drag or <span className="upload-highlight">Browse</span>
                </p>
                <p className="upload-subtitle">
                  File format supported: csv (Up to 50MB){' '}
                </p>
              </div>
            </Upload>
          </div>
        )}
      </Modal>

      <div className="media-header">
        <div className="media-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="actions__wrapper">
          {/* <Button
            type="danger"
            className="btn btn-danger media__delete"
            onClick={onDeleteButtonHandler}
          >
            Delete Media
          </Button> */}

          {/* <button className="btn-outline-primary" onClick={handleUpload}>
            <ImportIcon color="#64D5D2" size={18} />
            Import Tenant
          </button>

          <button className="btn-outline-primary" onClick={handleDownload}>
            <ExportIcon color="#64D5D2" size={18} />
            Export Tenant
          </button> */}
          {role !== 'superadmin' ? (
            access &&
            access.create && (
              <Link
                to={`/${siteId}/information/${siteName}/pois/new`}
                className="btn-primary"
              >
                <i className="feather-plus mr-2" />
                New Tenant
              </Link>
            )
          ) : (
            <Link
              to={`/${siteId}/information/${siteName}/pois/new`}
              className="btn-primary"
            >
              <i className="feather-plus mr-2" />
              New Tenant
            </Link>
          )}
        </div>
      </div>

      <div className="media-header">
        <div className="media-header-left">
          <div
            className="playlist-wrapper"
            onClick={() => setPlaylistOpen(!playlistOpen)}
          >
            <div className="playlist-selection">
              <ForwardIcon />
              <span>
                {selectedCategory === 'all'
                  ? 'All Categories'
                  : getCategory(selectedCategory)}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                playlistOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={categoriesList}
              setTempSelectedCategory={(id) => setTempSelectedCategory(id)}
              handleEditCategory={(cat) => handleEditCategory(cat)}
              handleDeleteCategory={(cat) => handleDeleteCategory(cat)}
              modalOpen={playlistOpen}
              handleSetPlaylist={handleSetPlaylist}
              tempSelectedCategory={tempSelectedCategory}
              handleNew={handleNew}
              filter={true}
            />
            {/* <div
              className={`playlist-dropdown ${
                playlistOpen
                  ? 'playlist-dropdown-open'
                  : 'playlist-dropdown-closed'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <ul>
                <li className="header" onClick={handleNew}>
                  <i className="feather-plus" />
                  Add New Category
                </li>
                <li>
                  <div
                    className={`radio ${
                      tempSelectedCategory === 'all' ? 'active' : ''
                    }`}
                    onClick={() => setTempSelectedCategory('all')}
                  >
                    {tempSelectedCategory === 'all' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  All Categories
                </li>

                {categoriesList.map((cat) => {
                  return (
                    <li key={cat._id}>
                      <div className="playlist-filter">
                        <div className="playlist-filter-radio">
                          <div
                            className={`radio ${
                              tempSelectedCategory === cat._id ? 'active' : ''
                            }`}
                            onClick={() => setTempSelectedCategory(cat._id)}
                          >
                            {tempSelectedCategory === cat._id && (
                              <div className="radio-checked" />
                            )}
                          </div>
                          {cat.name}
                        </div>
                        <Tooltip title="Options">
                          <Dropdown
                            trigger="click"
                            overlay={
                              <Menu>
                                <Menu.Item
                                  key="edit"
                                  onClick={() => handleEditCategory(cat)}
                                >
                                  <i className="feather-edit mr-2" />
                                  Edit
                                </Menu.Item>
                                <Menu.Divider />
                                <Menu.Item
                                  key="delete"
                                  onClick={() => handleDeleteCategory(cat)}
                                >
                                  <i className="feather-trash-2 mr-2" />
                                  Delete
                                </Menu.Item>
                              </Menu>
                            }
                          >
                            <button>
                              <i className="feather-more-horizontal" />
                            </button>
                          </Dropdown>
                        </Tooltip>
                      </div>
                    </li>
                  );
                })}
                <li className="playlist-button" onClick={handleSetPlaylist}>
                  Set Category
                </li>
              </ul>
            </div> */}
          </div>

          <div
            className="playlist-wrapper"
            onClick={() => setSortOpen(!sortOpen)}
          >
            <div className="playlist-selection">
              <SortIcon />
              <span>Sort By</span>
            </div>
            <i
              className={`feather-chevron-down ${
                sortOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <div
              className={`playlist-dropdown ${
                sortOpen ? 'playlist-dropdown-open' : 'playlist-dropdown-closed'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <ul>
                <li>
                  <div
                    className={`radio`}
                    onClick={() => handleSortTemp('sort', 'name')}
                  >
                    {sortByTemp.sort === 'name' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Name
                </li>
                <li>
                  <div
                    className={`radio`}
                    onClick={() => handleSortTemp('sort', 'location')}
                  >
                    {sortByTemp.sort === 'location' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Unit Number
                </li>
                <li className="divider" />
                <li>
                  <div
                    className={`radio`}
                    onClick={() => handleSortTemp('direction', 'asc')}
                  >
                    {sortByTemp.direction === 'asc' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Ascending
                </li>
                <li>
                  <div
                    className={`radio`}
                    onClick={() => handleSortTemp('direction', 'desc')}
                  >
                    {sortByTemp.direction === 'desc' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Descending
                </li>
                <li className="playlist-button" onClick={handleSort}>
                  Sort
                </li>
              </ul>
            </div>
          </div>

          <div
            className="playlist-wrapper"
            onClick={() => setFloorOpen(!floorOpen)}
          >
            <div className="playlist-selection">
              <LayerIcon />
              <span>
                {selectedFloor === 'all'
                  ? 'All Floor'
                  : getFloor(setSelectedFloor)}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                floorOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={floorList}
              setTempSelectedCategory={(id) => setTempSelectedFloor(id)}
              handleEditCategory={(cat) => handleEditFloor(cat)}
              handleDeleteCategory={(cat) => handleDeleteFloor(cat)}
              modalOpen={floorOpen}
              handleSetPlaylist={handleSetFloorCategory}
              tempSelectedCategory={tempSelectedFloor}
              handleNew={handleNewFloor}
              filter={true}
              title={'Floor'}
            />

            {/* <div
              className={`playlist-dropdown ${
                floorOpen
                  ? 'playlist-dropdown-open'
                  : 'playlist-dropdown-closed'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <ul>
                <li className="header" onClick={handleNewFloor}>
                  <i className="feather-plus" />
                  Add New Floor
                </li>
                <li>
                  <div
                    className={`radio ${
                      tempSelectedFloor === 'all' ? 'active' : ''
                    }`}
                    onClick={() => setTempSelectedFloor('all')}
                  >
                    {tempSelectedFloor === 'all' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  All Floor
                </li>

                {floorList.map((floor) => {
                  return (
                    <li key={floor._id}>
                      <div className="playlist-filter">
                        <div className="playlist-filter-radio">
                          <div
                            className={`radio ${
                              tempSelectedFloor === floor._id ? 'active' : ''
                            }`}
                            onClick={() => setTempSelectedFloor(floor._id)}
                          >
                            {tempSelectedFloor === floor._id && (
                              <div className="radio-checked" />
                            )}
                          </div>
                          {floor.name && floor.name.length > 15
                            ? `${floor.name.substr(0, 15)}...`
                            : floor.name}
                        </div>
                        <Tooltip title="Options">
                          <Dropdown
                            trigger="click"
                            overlay={
                              <Menu>
                                <Menu.Item
                                  key="edit"
                                  onClick={() => handleEditFloor(floor)}
                                >
                                  <i className="feather-edit mr-2" />
                                  Edit
                                </Menu.Item>
                                <Menu.Divider />
                                <Menu.Item
                                  key="delete"
                                  onClick={() => handleDeleteFloor(floor)}
                                >
                                  <i className="feather-trash-2 mr-2" />
                                  Delete
                                </Menu.Item>
                              </Menu>
                            }
                          >
                            <button>
                              <i className="feather-more-horizontal" />
                            </button>
                          </Dropdown>
                        </Tooltip>
                      </div>
                    </li>
                  );
                })}
                <li
                  className="playlist-button"
                  onClick={handleSetFloorCategory}
                >
                  Set Floor
                </li>
              </ul>
            </div> */}
          </div>

          {role === 'superadmin' && site && site.editorSiteId && (
            <div
              className="playlist-wrapper"
              onClick={() => setLinkOpen(!linkOpen)}
            >
              <div className="playlist-selection">
                <LayerIcon />
                <span>
                  {selectedLinkFilter === 'all'
                    ? 'Link Shape Filter'
                    : linkFilters.find(
                        (link) => link._id === selectedLinkFilter
                      )?.name}
                </span>
              </div>
              <i
                className={`feather-chevron-down ${
                  linkOpen ? 'playlist-open' : 'playlist-closed'
                }`}
              />

              <CategoryDropdown
                categories={linkFilters}
                setTempSelectedCategory={(id) => setTempSelectedLinkFilter(id)}
                modalOpen={linkOpen}
                handleSetPlaylist={handleSetLinkFilter}
                tempSelectedCategory={tempSelectedLinkFilter}
                filter={true}
                title={'Link Filter'}
              />
            </div>
          )}
        </div>
      </div>
      <div className="media-content-wrapper">
        <div className="media-content">
          <div className="media-tab-wrapper">
            <div className="media-tab-left">
              <div
                onClick={() => dispatch(setTabTenant('published'))}
                className={`media-tab ${
                  selectedTab === 'published' ? 'active' : ''
                }`}
              >
                Active Tenants
              </div>
              {/*<div*/}
              {/*  onClick={() => dispatch(setTabTenant('unpublished'))}*/}
              {/*  className={`media-tab ${*/}
              {/*    selectedTab === 'unpublished' ? 'active' : ''*/}
              {/*  }`}*/}
              {/*>*/}
              {/*  Unpublished Tenants*/}
              {/*</div>*/}
              <div
                onClick={() => dispatch(setTabTenant('archived'))}
                className={`media-tab ${
                  selectedTab === 'archived' ? 'active' : ''
                }`}
              >
                Removed Tenants
              </div>
            </div>
          </div>
          <div className="media-list-content">
            {filteredData.length > 0 && filteredData.length > 0 ? (
              _.chunk(filteredData, 3).map((chunk, index) => {
                return (
                  <div className="media-list-chunk" key={index}>
                    {chunk.map((poi) => {
                      return (
                        <div
                          key={poi._id}
                          data-id={poi._id}
                          className="media-list"
                        >
                          <Cards
                            data={poi}
                            type="tenant"
                            {...getShapeTagProps(poi)}
                            isShowMedia={true}
                            editAction={() => handleEdit(poi._id)}
                            deleteAction={() =>
                              onRemoveButtonClickHandler(poi._id)
                            }
                          />
                        </div>
                      );
                    })}
                    {chunk.length < 2 && <div className="media-list-empty" />}
                    {chunk.length < 3 && <div className="media-list-empty" />}
                  </div>
                );
              })
            ) : (
              <div className="media-empty">
                <Empty image={EmptyIcon} description="No Tenant" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pois;
